import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../../../_actions/dataActions";
import Wrapper from "../../../../../../_hoc/Wrapper";
import PageSubTitle from "../../../../../UI/PageSubTitle";
import EditWidget from "../../../../../UI/EditWidget";
import Select from "../../../../../UI/Select";
import getHeight from "../../../../../../_selectors/dataSelectors/getHeight";
import getComplexion from "../../../../../../_selectors/dataSelectors/getComplexion";
import getBodyType from "../../../../../../_selectors/dataSelectors/getBodyType";
import getDisability from "../../../../../../_selectors/dataSelectors/getDisability";

class PhysicalDetail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userProfile) {
      const {
        height,
        weight,
        complexion,
        bodyType,
        disability
      } = nextProps.userProfile;
      const {
        isEditModeOn,
        selectedHeight,
        selectedWeight,
        selectedComplexion,
        selectedBodyType,
        selectedDisability
      } = prevState;
      if (isEditModeOn) {
        return null;
      } else {
        if (
          height !== selectedHeight ||
          weight !== selectedWeight ||
          complexion !== selectedComplexion ||
          bodyType !== selectedBodyType ||
          disability !== selectedDisability
        ) {
          return {
            selectedBodyType: bodyType,
            selectedComplexion: complexion,
            selectedDisability: disability,
            selectedHeight: height,
            selectedWeight: weight
          };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  state = {
    isEditModeOn: false,
    showEdit: this.props.showEdit,
    selectedHeight: null,
    selectedWeight: null,
    selectedComplexion: null,
    selectedBodyType: null,
    selectedDisability: null
  };
  componentDidMount() {
    const {
      height,
      complexion,
      bodyType,
      disability,
      getHeightData,
      getComplexionData,
      getBodyTypeData,
      getDisabilityData
    } = this.props;
    if (height.length === 0) {
      getHeightData();
    }
    if (complexion.length === 0) {
      getComplexionData();
    }
    if (bodyType.length === 0) {
      getBodyTypeData();
    }
    if (disability.length === 0) {
      getDisabilityData();
    }
    let weightOptions = [];
    for (let index = 40; index < 150; index++) {
      weightOptions.push({ label: `${index} Kg`, value: index });
    }
    this.weightOptions = weightOptions;
  }
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const {
      selectedBodyType,
      selectedComplexion,
      selectedDisability,
      selectedHeight,
      selectedWeight
    } = this.state;
    const { update, toast } = this.props;
    const updatedPhysicalDetail = {
      height: selectedHeight,
      weight: selectedWeight,
      complexion: selectedComplexion,
      bodyType: selectedBodyType,
      disability: selectedDisability
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
      toast({ type: "info", message: "Profile Updated" });
    };
    const onError = err => {
      toast({ type: "error", message: err });
    };
    update({ data: updatedPhysicalDetail, onSuccess, onError });
  };
  render() {
    const {
      isEditModeOn,
      selectedBodyType,
      selectedComplexion,
      selectedDisability,
      selectedHeight,
      selectedWeight,
      showEdit
    } = this.state;
    const {
      height,
      complexion,
      bodyType,
      disability,
      userProfile
    } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Physical Detail
            <EditWidget
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={userProfile.cache}
              show={showEdit}
            />
          </h3>
          <p />
        </PageSubTitle>
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Height</Wrapper>}
                selected={selectedHeight}
                options={height}
                onChange={value => {
                  this.setState({ selectedHeight: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <Select
                label={<Wrapper>Weight</Wrapper>}
                selected={selectedWeight}
                options={this.weightOptions}
                onChange={value => {
                  this.setState({ selectedWeight: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Select
                label={<Wrapper>Complexion</Wrapper>}
                selected={selectedComplexion}
                options={complexion}
                onChange={value => {
                  this.setState({ selectedComplexion: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Body Type</Wrapper>}
                selected={selectedBodyType}
                options={bodyType}
                onChange={value => {
                  this.setState({ selectedBodyType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Physical Status</Wrapper>}
                selected={selectedDisability}
                options={disability}
                onChange={value => {
                  this.setState({ selectedDisability: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  height: getHeight(state),
  complexion: getComplexion(state),
  bodyType: getBodyType(state),
  disability: getDisability(state)
});
const mapDispatchToProps = dispatch => ({
  getHeightData: () => dispatch(dataActions.getHeight()),
  getComplexionData: () => dispatch(dataActions.getComplexion()),
  getBodyTypeData: () => dispatch(dataActions.getBodyType()),
  getDisabilityData: () => dispatch(dataActions.getDisability())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhysicalDetail);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Physical/PhysicalDetail/index.js